export const flags = {
  schema: true,
  annotationTechnical: true,
  annotationGeneral: true,
  compareMetadata: true,
  mergeMetadata: true,

  publishGitHub: false,
  publishORKG: false,
};
